// src/CustomerBooking/CustomerBookingPage.js
// Standalone page for customer reservations
import React from 'react';
import CustomerReservationForm from './CustomerReservationForm';

const CustomerBookingPage = () => {
  // Get URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const companyId = urlParams.get('company');
  const companyName = urlParams.get('name') || 'Bike Rental Company';

  // Debug logging
  console.log('CustomerBookingPage loaded');
  console.log('URL:', window.location.href);
  console.log('Company ID:', companyId);
  console.log('Company Name:', companyName);

  // Show error if no company ID
  if (!companyId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-blue-900 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="text-white text-2xl">!</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Invalid Booking Link</h2>
          <p className="text-gray-600 mb-6">
            This booking link appears to be incomplete or invalid. Please contact the bike rental company for a valid booking link.
          </p>
          <div className="text-sm text-gray-500">
            <p>Expected format: /customer-booking?company=COMPANY_ID&name=COMPANY_NAME</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <CustomerReservationForm 
        companyId={companyId}
        companyName={decodeURIComponent(companyName)}
      />
    </div>
  );
};

export default CustomerBookingPage;